import React, { Fragment } from 'react';
import { Drawer, DrawerBody, DrawerHeader, Link, Typography, } from '@one-thd/sui-atomic-components';
import { Returns, QRCode, BuyAgain } from '@one-thd/sui-icons';
import { getItemsByShipment } from '@src/utils';
import '../../styles/returns.scss';
import PostSelectionItems from '../items-to-return/PostSelectionItems';
import { useSummaryStore } from '../../stores/summaryStore';
var ViewUpsBarcodeDrawer = function (_a) {
    var displayDrawer = _a.displayDrawer, closeDrawer = _a.closeDrawer, shipment = _a.shipment;
    var selectedReturnItems = useSummaryStore(function (state) { return state.selectedReturnItems; });
    var trackingDetails = useSummaryStore(function (state) { return state.trackingDetails; });
    var isMultiAddressReturn = useSummaryStore(function (state) { return state.isMultiAddressReturn; });
    var items = isMultiAddressReturn
        ? getItemsByShipment(shipment, selectedReturnItems)
        : selectedReturnItems;
    var trackingInfo = isMultiAddressReturn
        ? shipment === null || shipment === void 0 ? void 0 : shipment.trackingDetails
        : trackingDetails;
    var renderUpsBarcodeImgs = function () {
        var base64decode = 'data:image/png;base64,';
        return trackingInfo === null || trackingInfo === void 0 ? void 0 : trackingInfo.map(function (trackingDetail, index) {
            var imageSource = base64decode + trackingDetail.upsBarcodeImg;
            return (React.createElement(Fragment, { key: index },
                trackingInfo.length !== 1 && (React.createElement("hr", { "data-testid": "divider", className: "sui-mb-4" })),
                React.createElement(Typography, null,
                    "Barcode ",
                    index + 1,
                    " of ",
                    trackingInfo.length),
                React.createElement("div", { className: "sui-mb-4 sui-mt-4" },
                    React.createElement("img", { className: "sui-max-w-[420px] sui-w-full", key: index, src: imageSource, alt: "UPS Barcode ".concat(index + 1), height: 116, width: 233 }))));
        });
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96" },
        React.createElement(Drawer, { open: displayDrawer, onClose: closeDrawer, position: "right", className: "drawer-z-index-fix" },
            React.createElement(DrawerHeader, { title: "UPS Barcode", onClose: closeDrawer }),
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: "sui-mb-4" },
                    React.createElement(Typography, null, "Return Items")),
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-mb-4" },
                    React.createElement(PostSelectionItems, { selectedReturnItems: items })),
                React.createElement("div", { "data-testid": "barcode-imgs-size-".concat(trackingInfo === null || trackingInfo === void 0 ? void 0 : trackingInfo.length) }, renderUpsBarcodeImgs()),
                React.createElement("hr", { className: "sui-mb-4" }),
                React.createElement("div", { className: "sui-mb-4 sui-flex sui-gap-3" },
                    React.createElement("div", { className: "sui-pt-[6px]" },
                        React.createElement(Returns, null)),
                    React.createElement(Typography, null, "Pack your return items in a box.")),
                React.createElement("div", { className: "sui-mb-4 sui-flex sui-gap-3" },
                    React.createElement("div", { className: "sui-pt-[6px]" },
                        React.createElement(QRCode, null)),
                    React.createElement(Typography, null,
                        "Present your barcode to an associate at",
                        ' ',
                        React.createElement(Link, { href: "https://www.theupsstore.com/tools/find-a-store", target: "_blank" }, "select UPS locations"))),
                React.createElement("div", { className: "sui-flex sui-gap-3" },
                    React.createElement("div", { className: "sui-pt-[6px]" },
                        React.createElement(BuyAgain, null)),
                    React.createElement(Typography, null, "It may take up to 10 business days for your bank to put the funds back into your account."))))));
};
export default ViewUpsBarcodeDrawer;
